import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font
} from '@react-pdf/renderer';

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
    fontFamily: 'Helvetica',
  },
  header: {
    borderBottom: '2 solid black',
    paddingBottom: 8,
    marginBottom: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  outletInfo: {
    textAlign: 'right',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#d3e3be',
    border: '1 solid gray',
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1 solid gray',
  },
  cell: {
    padding: 4,
    borderRight: '1 solid gray',
  },
  column: (width) => ({
    width,
    padding: 4,
    borderRight: '1 solid gray',
  }),
  groupHeader: {
    flexDirection: 'row',
    borderBottom: '1 solid gray',
    fontWeight: 'bold',
    backgroundColor: '#f0f0f0',
  },
  subtotalRow: {
    flexDirection: 'row',
    borderTop: '1 solid gray',
    fontWeight: 'bold',
    marginTop: 4,
  },
  grandTotalRow: {
    flexDirection: 'row',
    borderTop: '2 solid black',
    fontWeight: 'bold',
    marginTop: 10,
  },
});

// Component
const SalesRegisterDetailsReportPDFDocumentForDownload = ({
  salesDetails,
  grandNetTotal,
  userInfo,
  invoice,
  grandNetTotalQuantity,
  formData,
  currencyData,
}) => {
  const groupedSales = Object.entries(
    salesDetails.reduce((acc, sale) => {
      const key = `${sale.invoice_id}-${sale.created_at.substring(0, 10)}`;
      if (!acc[key]) acc[key] = [];
      acc[key].push(sale);
      return acc;
    }, {})
  );

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View>
            <Text style={{ fontWeight: 'bold', fontSize: 12 }}>Sales Register Details Report</Text>
            <Text>{`${new Date(formData.start_date).toLocaleDateString('en-GB')} to ${new Date(formData.end_date).toLocaleDateString('en-GB')}`}</Text>
          </View>
          <View style={styles.outletInfo}>
            <Text style={{ fontWeight: 'bold', fontSize: 10 }}>{userInfo?.outlet_name}</Text>
            <Text>{userInfo?.address}</Text>
            <Text>Mobile- {userInfo?.phone}</Text>
          </View>
        </View>

        {/* Table Header */}
        <View style={styles.tableHeader}>
          <Text style={styles.column('13%')}>Date</Text>
          <Text style={styles.column('13%')}>Invoice No.</Text>
          <Text style={styles.column('34%')}>Products</Text>
          <Text style={styles.column('10%')}>Qty/Unit</Text>
          <Text style={styles.column('15%')}>Price</Text>
          <Text style={styles.column('15%')}>Total Amount</Text>
        </View>

        {/* Grouped Rows */}
        {groupedSales.map(([groupKey, salesGroup], groupIndex) => {
          const matchingInvoice = invoice.find(
            (inv) => inv.invoice_id === salesGroup[0]?.invoice_id
          );

          return (
            <React.Fragment key={groupIndex}>
              {/* Group Header */}
              <View style={styles.groupHeader}>
                <Text style={styles.column('13%')}>{salesGroup[0]?.created_at.substring(0, 10)}</Text>
                <Text style={styles.column('13%')}>{salesGroup[0]?.invoice_id.split('-').pop()}</Text>
                <Text style={styles.column('34%')}>{salesGroup[0]?.customer_name}</Text>
                <Text style={styles.column('40%')}></Text>
              </View>

              {/* Sales Rows */}
              {salesGroup.map((sale) => (
                <View key={sale.id} style={styles.tableRow}>
                  <Text style={styles.column('13%')}></Text>
                  <Text style={styles.column('13%')}></Text>
                  <Text style={styles.column('34%')}>{sale?.product_info?.name || 'N/A'}</Text>
                  <Text style={styles.column('10%')}>{sale?.qty}</Text>
                  <Text style={styles.column('15%')}>{parseFloat(sale.price).toFixed(2)}</Text>
                  <Text style={styles.column('15%')}>{parseFloat(sale.total_amount).toFixed(2)}</Text>
                </View>
              ))}

              {/* Subtotal Row */}
              <View style={styles.subtotalRow}>
                <Text style={styles.column('60%')}>Subtotal:</Text>
                <Text style={styles.column('10%')}>{matchingInvoice?.sub_total_quantity || 'N/A'}</Text>
                <Text style={styles.column('30%')}>
                  {matchingInvoice?.sub_total ? parseFloat(matchingInvoice.sub_total).toFixed(2) : 'N/A'}
                </Text>
              </View>
            </React.Fragment>
          );
        })}

        {/* Grand Total Row */}
        <View style={styles.grandTotalRow}>
          <Text style={styles.column('60%')}>Grand Net Total:</Text>
          <Text style={styles.column('10%')}>{grandNetTotalQuantity}</Text>
          <Text style={styles.column('30%')}>{parseFloat(grandNetTotal).toFixed(2)}</Text>
        </View>
      </Page>
    </Document>
  );
};

export default SalesRegisterDetailsReportPDFDocumentForDownload;
